module.exports = __webpack_public_path__ + "img/train-2.6e17ac89.jpg";